import { useEffect, useState } from "react";
import api from "../lib/api";
import { fmtDateTime } from "../lib/format";
import { Badge } from "../components/ui/badge";
import { toast } from "sonner";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/audit").then((r) => setLogs(r.data)).catch(() => toast.error("Failed to load audit log"));
  }, []);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <h1 className="font-heading text-3xl font-bold">Audit Log</h1>
        <p className="text-muted-foreground mt-1">Who changed revenue/tips, percentages and payroll — and when</p>
      </div>
      <div className="glass border border-border rounded-lg overflow-x-auto">
        <table className="w-full text-sm min-w-[760px]">
          <thead>
            <tr className="border-b text-left text-muted-foreground">
              <th className="px-4 py-3 font-medium">When</th>
              <th className="px-4 py-3 font-medium">Who</th>
              <th className="px-4 py-3 font-medium">Entity</th>
              <th className="px-4 py-3 font-medium">Action</th>
              <th className="px-4 py-3 font-medium">Details</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-b last:border-0" data-testid={`audit-row-${l.id}`}>
                <td className="px-4 py-2.5 whitespace-nowrap">{fmtDateTime(l.at)}</td>
                <td className="px-4 py-2.5">{l.actor_name}</td>
                <td className="px-4 py-2.5"><Badge variant="outline">{l.entity}</Badge></td>
                <td className="px-4 py-2.5 capitalize">{l.action}</td>
                <td className="px-4 py-2.5 text-muted-foreground">{l.details}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={5} className="px-4 py-8 text-center text-muted-foreground">No activity recorded yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
